import { IconProps } from '@models/icons';

function RightIcon({ size, color, ...rest }:IconProps) {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <path d="M11.6998 4.2L15.2998 9L11.6998 13.8" stroke="#AFA8A5" strokeWidth="1.4" strokeLinecap="round"
                strokeLinejoin="round"/>
        </svg>
    );
}

export default RightIcon;
